import { useEffect } from 'react';
import { usePreproductPreviewContext } from '../context/Context';
import { PREPROD_PREVIEW_ACTIONS } from '../context/types';
export var useFullscreenListener = function useFullscreenListener() {
  var _usePreproductPreview = usePreproductPreviewContext(),
      dispatch = _usePreproductPreview.dispatch;

  useEffect(function () {
    var onMessage = function onMessage(event) {
      if (event.data.type === 'LITE_USE_FULLSCREEN') {
        dispatch({
          type: PREPROD_PREVIEW_ACTIONS.TOGGLE_MODAL
        });
      }
    };

    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [dispatch]);
};